import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { PROVIDER_NAME } from 'Common/consts';
import { getProviders } from 'PhenotypeCatalogueView/store/selectors';
import { useSelector } from 'react-redux';
import styles from './CatalogueMenu.css';
const CatalogueMenu = ({ activeProvider, changeProviderHandler, }) => {
    const providersList = useSelector(getProviders);
    return (_jsx("div", Object.assign({ className: styles.container }, { children: providersList.map((provider) => {
            const className = classNames(styles.providerButton, {
                [styles.active]: activeProvider === provider,
            });
            return (_jsx("button", Object.assign({ type: "button", className: className, onClick: () => changeProviderHandler(provider) }, { children: PROVIDER_NAME[provider] }), provider));
        }) }), void 0));
};
export default CatalogueMenu;
